new Vue({
    delimiters: ['[[', ']]'], // change because vue and django using the same args 
    el: '#product-detail',
    data: {
        // Showcase
        showOpened: false,
        expandDesc: false,
        installmentOpened: false,

        //Thumb
        imgSrc: '',
        imgTitle: '',
        isVideo: ''
    },
    methods: {
        resizeThumbs() {
            const contentThumbs = document.querySelector('#product-photo');
            const imgThumb = document.querySelector('#product-photo img');
            if (contentThumbs && imgThumb) {
                let heightImg = imgThumb.getBoundingClientRect().height;
                contentThumbs.style.minHeight = heightImg + 'px';
            }
        },
        clickThumbs() {
            let photoArea = document.querySelector('.product-detail__header--photoArea');
            let photoThumbs = document.querySelector('.product-detail__header--photoArea-thumbs');

            if (photoThumbs && photoArea) {
                if (photoArea.classList.contains('gallery-left') || photoArea.classList.contains('gallery-right') || photoArea.classList.contains('gallery-bottom')) {

                    let photoListItem = document.querySelectorAll('#photo-list li');
                    let singlePhotoItem = document.querySelectorAll('#product-photo img');

                    if (photoListItem.length && singlePhotoItem.length) {
                        photoListItem[0].classList.add('active');
                        singlePhotoItem[0].classList.add('active');

                        function activeTab(index) {
                            singlePhotoItem.forEach((content) => {
                                content.classList.remove('active');
                            });
                            singlePhotoItem[index].classList.add('active');
                        }

                        photoListItem.forEach((itemMenu, index) => {
                            itemMenu.addEventListener('click', () => {
                                activeTab(index);
                            });
                        });
                    }
                }
            }

            if (photoThumbs && photoArea) {
                if (photoThumbs.classList.contains('gallery-left') || photoThumbs.classList.contains('gallery-right')) {
                    $('#photo-list').slick({
                        infinite: false,
                        slidesToShow: 5,
                        vertical: true,
                        slidesToScroll: 1
                    });
                }
            }
        },
        updateImageThumb(src) {
            this.imgSrc = src;
        },

        setThumbHeight() {
            return document.querySelector('.product-detail__header--photoArea-thumbs').style.height = document.querySelector('#photo-list li.visible').clientHeight * this.slidesToShow + 'px;';
        },

        handleESC(event) {
            if (event.key === 'Escape')
                this.showOpened = false
        },

        checkBuyView() {
            const buyButton = document.getElementById("buy-button");
            const rect = buyButton.getBoundingClientRect();

            if (rect.top >= 0 && rect.bottom <= window.innerHeight) {
                const otherElement = document.querySelector(".product-detail__fixed--buy");
                if (otherElement) {
                    otherElement.classList.remove("active");
                }
            } else {
                const otherElement = document.querySelector(".product-detail__fixed--buy");
                if (otherElement) {
                    otherElement.classList.add("active");
                }
            }
        },

        zoom(event) {
            const container = document.getElementById('zoom-container');
            const image = document.getElementById('zoom-image');

            const containerRect = container.getBoundingClientRect();
            const mouseX = event.clientX - containerRect.left;
            const mouseY = event.clientY - containerRect.top;

            if (mouseX >= 0 && mouseX <= containerRect.width && mouseY >= 0 && mouseY <= containerRect.height) {
                const zoomLevel = 1.2;
                const newWidth = container.offsetWidth * zoomLevel;
                const newHeight = container.offsetHeight * zoomLevel;

                const offsetX = -(mouseX * (zoomLevel - 1));
                const offsetY = -(mouseY * (zoomLevel - 1));

                image.style.transform = `translate(${offsetX}px, ${offsetY}px) scale(${zoomLevel})`;

                if (offsetX > 0) {
                    image.style.transform = `translate(0, ${offsetY}px) scale(${zoomLevel})`;
                }
                if (offsetY > 0) {
                    image.style.transform = `translate(${offsetX}px, 0) scale(${zoomLevel})`;
                }
                if (offsetX < -(newWidth - container.offsetWidth)) {
                    image.style.transform = `translate(${- (newWidth - container.offsetWidth)}px, ${offsetY}px) scale(${zoomLevel})`;
                }
                if (offsetY < -(newHeight - container.offsetHeight)) {
                    image.style.transform = `translate(${offsetX}px, ${- (newHeight - container.offsetHeight)}px) scale(${zoomLevel})`;
                }
            }
        },

        resetZoom() {
            const image = document.getElementById('zoom-image');
            image.style.transform = 'translate(0, 0) scale(1)';
        }
    },
    mounted() {
        // Esconde o less-stock inicialmente
        const initialLessStock = document.querySelectorAll('.less-stock');
        initialLessStock.forEach(element => {
            element.style.display = 'none';
        });

        this.clickThumbs();

        let description = document.querySelector('.description-nav');
        if (description) {
            let navTab = description.querySelectorAll('.nav-item');
            let navShow = description.querySelectorAll('.description-nav-content');
            navTab = Array.from(navTab);
            navShow = Array.from(navShow);

            if (navTab.length && navShow.length) {
                function resetVerMais(content) {
                    const navShowEl = content.querySelector('.nav-show');
                    if (!navShowEl) return;
                    navShowEl.classList.remove('expanded');
                    content.style.maxHeight = '';
                    const btn = content.querySelector('.btn-ver-mais');
                    if (btn) btn.textContent = 'Ver mais';
                }

                function activeTab(index) {
                    const isAlreadyActive = navTab[index].classList.contains('active') && navShow[index].classList.contains('active');
                    if (isAlreadyActive) {
                        resetVerMais(navShow[index]);
                        navTab[index].classList.remove('active');
                        navShow[index].classList.remove('active');
                        return;
                    }
                    navTab.forEach((content) => {
                        content.classList.remove('active');
                    });
                    navTab[index].classList.add('active');
                    navShow.forEach((content) => {
                        resetVerMais(content);
                        content.classList.remove('active');
                    });
                    navShow[index].classList.add('active');

                    // Scroll suave para o topo do item clicado
                    setTimeout(() => {
                        const header = document.querySelector('header') || document.querySelector('.header');
                        const headerHeight = header ? header.getBoundingClientRect().height : 0;
                        const itemPosition = navTab[index].getBoundingClientRect().top + window.pageYOffset;
                        const scrollPosition = itemPosition - headerHeight - 30;

                        window.scrollTo({
                            top: scrollPosition,
                            behavior: 'smooth'
                        });
                    }, 300);
                }

                function initVerMais() {
                    navShow.forEach((content) => {
                        const navShowEl = content.querySelector('.nav-show');
                        if (!navShowEl || navShowEl.scrollHeight <= 500) return;

                        navShowEl.classList.add('limited');

                        const btn = document.createElement('button');
                        btn.className = 'btn-ver-mais';
                        btn.textContent = 'Ver mais';
                        content.appendChild(btn);

                        btn.addEventListener('click', (e) => {
                            e.stopPropagation();
                            const isExpanded = navShowEl.classList.contains('expanded');
                            if (isExpanded) {
                                navShowEl.classList.remove('expanded');
                                btn.textContent = 'Ver mais';
                                content.style.maxHeight = '';
                            } else {
                                navShowEl.classList.add('expanded');
                                btn.textContent = 'Ver menos';
                                content.style.maxHeight = (navShowEl.scrollHeight + btn.offsetHeight + 32) + 'px';
                            }
                        });
                    });
                }

                navTab.forEach((itemMenu, index) => {
                    itemMenu.addEventListener('click', () => {
                        activeTab(index);
                    });
                });

                initVerMais();

                window.addEventListener('resize', () => {
                }, { passive: true });
            }
        }

        const photoList = document.getElementById("photo-list");
        if (photoList) {
            const firstLi = photoList.querySelector("li");
            if (firstLi) {
                const imgElement = firstLi.querySelector("img");

                if (imgElement) {
                    this.imgSrc = imgElement.getAttribute("src");
                    this.imgTitle = imgElement.getAttribute("title");
                }
            }
        }

        const ratingName = document.querySelector('.product-detail__rating__amount');
        if (ratingName !== null)
            if (ratingName.textContent === 'Seja o primeiro a avaliar')
                ratingName.textContent = 'Avaliar';

        const userLetterElement = document.getElementById('user_letter');
        if (userLetterElement) {
            const userLetter = userLetterElement.innerText.trim();
            if (userLetter.length > 0) {
                userLetterElement.innerText = userLetter[0];
            }
        }

        document.addEventListener('keydown', this.handleESC, { passive: true });
        window.addEventListener("scroll", this.checkBuyView, { passive: true });
        window.addEventListener("load", this.checkBuyView, { passive: true });
    },
    beforeDestroy() {
        document.removeEventListener('keydown', this.handleESC);
    },
    watch: {
        showOpened(newValue) {
            if (newValue) {
                document.body.style.overflow = 'hidden';
            } else {
                document.body.style.removeProperty('overflow');
            }
        },
    }
})

$(document).ready(function () {

    const cashback = document.querySelector('.cashback-themes');
    if (cashback) {
        const cashbackValue = cashback.querySelector('.cashback-themes-value');

        // Converte "R$ 1.234,56" / "10%" em número
        function toNumber(text) {
            if (!text) return NaN;

            let clean = text.replace(/[^\d,.]/g, '');

            if (clean.indexOf(',') > -1) {
                clean = clean.replace(/\./g, '').replace(',', '.');
            }

            return parseFloat(clean);
        }

        function updateCashback() {
            const priceFull = document.querySelector('.price-full');
            if (!cashbackValue || !priceFull) return;

            const percentage = toNumber(cashback.getAttribute('data-percentage'));
            const price = toNumber(priceFull.textContent);

            if (isNaN(percentage) || isNaN(price)) {
                cashbackValue.textContent = '';
                return;
            }

            cashbackValue.textContent = (price * percentage / 100).toLocaleString('pt-BR', {
                style: 'currency',
                currency: 'BRL'
            });
        }

        updateCashback();

        // O preço é re-renderizado ao trocar de variação
        const priceArea = document.querySelector('.price');
        if (priceArea) {
            new MutationObserver(updateCashback).observe(priceArea, {
                childList: true,
                subtree: true,
                characterData: true
            });
        }
    }

    // Seleciona as variações da página e do popup
    const variationsInfo = document.querySelectorAll('.product-detail__header--infoArea .product-radio-variation .label_radio');
    const variationsPopup = document.querySelectorAll('.shoppub-fast-buy-popup .product-radio-variation .label_radio');

    // Define o texto inicial no botão da infoArea
    const infoButton = document.querySelector('#buy-button .btn-buy');
    if (infoButton) infoButton.textContent = "Selecione um tamanho";

    // Função que marca que houve seleção
    function handleVariationClick() {
        const popupBtn = document.querySelector('.shoppub-fast-buy-popup .wrapper-buttons');
        const infoBtn = document.querySelector('.product-detail__header--infoArea #buy-button');

        [popupBtn, infoBtn].forEach(btn => {
            if (btn) btn.classList.add('active');
        });
    }

    // Adiciona listener às variações da infoArea
    variationsInfo.forEach(variation => {
        variation.addEventListener('click', handleVariationClick);
    });

    // Adiciona listener às variações do popup
    variationsPopup.forEach(variation => {
        variation.addEventListener('click', handleVariationClick);
    });

    // Observa mudanças no DOM para reaplicar a classe se o botão do popup for recriado
    const observer = new MutationObserver(() => {
        const popupBtn = document.querySelector('.shoppub-fast-buy-popup .wrapper-buttons');
        if (popupBtn) {
            const variationsPopup = document.querySelectorAll('.shoppub-fast-buy-popup .product-radio-variation .label_radio');
            variationsPopup.forEach(variation => {
                variation.addEventListener('click', () => {
                    $('.product-radio-variation').addClass('active');
                });
            });
        }
    });

    observer.observe(document.body, { childList: true, subtree: true });


    // if (window.matchMedia("(min-width: 992px)").matches) {
    //     function animeScroll() {
    //         const photoScroll = document.querySelector('.product-detail__header--photoArea');
    //         const sidebarInner = document.querySelector('.sidebar__inner');

    //         if (photoScroll && sidebarInner && photoScroll.offsetHeight > sidebarInner.offsetHeight) {
    //             const containerWidth = $('.product-detail__header--infoArea').width();
    //             const sidebarInnerHeight = sidebarInner.offsetHeight;
    //             const totalHeight = photoScroll.offsetHeight - sidebarInnerHeight;
    //             const pageTop = window.pageYOffset;
    //             const rect = photoScroll.getBoundingClientRect();
    //             const offsetTop = rect.top + pageTop; // Calculate the distance from top of the page to the photoScroll

    //             if (pageTop > (offsetTop + totalHeight)) {
    //                 $('.sidebar__inner').css({ position: 'relative', top: totalHeight + 'px', maxWidth: '100%' });
    //             } else if (pageTop > offsetTop) {
    //                 $('.sidebar__inner').css({ position: 'fixed', top: '0px', maxWidth: containerWidth + 'px' });
    //             } else {
    //                 $('.sidebar__inner').css({ position: 'relative', top: '0px', maxWidth: '100%' });
    //                 $('.sidebar__inner').css({ paddingTop: '0' + 'px' });
    //             }
    //         }
    //     }

    //     window.addEventListener('scroll', function () {
    //         animeScroll();
    //     });

    //     animeScroll();

    //     // Função para gerenciar resume-description
    //     function handleResumeDescription() {
    //         const resumeDescription = document.querySelector('.resume-description');

    //         if (resumeDescription) {
    //             const children = resumeDescription.children;
    //             let totalHeight = 0;

    //             // Calcula a altura total dos filhos
    //             Array.from(children).forEach(child => {
    //                 totalHeight += child.offsetHeight;
    //             });

    //             // Se a altura total for maior que 300px
    //             if (totalHeight > 300) {
    //                 // Define a altura máxima no elemento pai
    //                 resumeDescription.classList.add('closed');
    //                 resumeDescription.style.height = totalHeight + 'px';

    //                 // Cria o botão "Ver mais"
    //                 const button = document.createElement('button');
    //                 button.textContent = 'Ver mais';
    //                 button.className = 'resume-description-toggle';

    //                 // Adiciona o botão após o resume-description
    //                 resumeDescription.parentNode.insertBefore(button, resumeDescription.nextSibling);

    //                 // Adiciona evento de clique ao botão
    //                 button.addEventListener('click', function () {
    //                     if (resumeDescription.classList.contains('closed')) {
    //                         // Remove a classe closed e mostra todo o conteúdo
    //                         resumeDescription.classList.remove('closed');
    //                         resumeDescription.style.maxHeight = totalHeight + 'px';
    //                         button.textContent = 'Ver menos';

    //                         // Chama animeScroll após a animação
    //                         setTimeout(() => {
    //                             if (typeof animeScroll === 'function') {
    //                                 animeScroll();
    //                             }
    //                         }, 300);
    //                     } else {
    //                         // Adiciona a classe closed e esconde o conteúdo
    //                         resumeDescription.classList.add('closed');
    //                         button.textContent = 'Ver mais';

    //                         // Chama animeScroll após a animação
    //                         setTimeout(() => {
    //                             if (typeof animeScroll === 'function') {
    //                                 animeScroll();
    //                             }
    //                         }, 300);
    //                     }
    //                 });
    //             }
    //         }
    //     }

    //     // Executa a função quando o documento estiver pronto
    //     handleResumeDescription();
    // }

    const brinde = document.querySelector('#js_buy_together_api_layout_2');
    if (brinde) {
        const observer = new MutationObserver(mutations => {
            mutations.forEach(mutation => {
                mutation.addedNodes.forEach(node => {
                    if (node.nodeType === 1) { // Verifica se o nó é um elemento HTML
                        if (node.id === 'js_buy_together_api_group_1' || node.querySelector('#js_buy_together_api_group_1')) {
                            const targetNode = node.id === 'js_buy_together_api_group_1' ? node : node.querySelector('#js_buy_together_api_group_1');
                            const options = targetNode.querySelector('.product-item__options');
                            const figcaption = targetNode.querySelector('.product-item__content--figcaption');

                            if (options && figcaption) {
                                figcaption.append(options);
                            }

                            const widget = targetNode.querySelector('div[id^="widget_tools__product_detail_list_"]');
                            const sizes = targetNode.querySelector('.product-radio-variation');

                            if (widget && sizes) {
                                widget.addEventListener('click', () => {
                                    sizes.classList.toggle('active');
                                });

                                const allSizes = sizes.querySelectorAll('label');
                                allSizes.forEach(size => {
                                    size.addEventListener('click', () => {
                                        sizes.classList.toggle('active');
                                        widget.setAttribute('data-before', size.textContent);
                                    });
                                });
                            }
                        }
                        if (node.id === 'js_buy_together_api_group_2' || node.querySelector('#js_buy_together_api_group_2')) {
                            const targetNode = node.id === 'js_buy_together_api_group_2' ? node : node.querySelector('#js_buy_together_api_group_2');
                            const options = targetNode.querySelector('.product-item__options');
                            const figcaption = targetNode.querySelector('.product-item__content--figcaption');

                            if (options && figcaption) {
                                figcaption.append(options);
                            }

                            const widget = targetNode.querySelector('div[id^="widget_tools__product_detail_list_"]');
                            const sizes = targetNode.querySelector('.product-radio-variation');

                            if (widget && sizes) {
                                widget.addEventListener('click', () => {
                                    sizes.classList.toggle('active');
                                });

                                const allSizes = sizes.querySelectorAll('label');
                                allSizes.forEach(size => {
                                    size.addEventListener('click', () => {
                                        sizes.classList.toggle('active');
                                        widget.setAttribute('data-before', size.textContent);
                                    });
                                });
                            }
                        }
                    }
                });
            });
        });

        observer.observe(brinde, {
            childList: true,
            subtree: true
        });

    }

    waitForElementToExist('.price-buy-together').then(element => {
        if (window.matchMedia("(min-width: 991px)").matches) {
            if (element) {
                const buyTogetherContent = document.querySelector('.buy-together-content');
                const heightContent = buyTogetherContent.getBoundingClientRect().height;
                const buyTogetherTitle = document.querySelector('.buy-together-title');
                if (buyTogetherTitle && buyTogetherContent) {
                    buyTogetherTitle.style.height = heightContent + 'px'
                }
            }
        }
    });

    if ($('.product-detail__header--photoArea-mobile')) {
        $('.product-detail__header--photoArea-mobile').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            dots: true,
            adaptiveHeight: true,
            infinite: false,
            mobileFirst: true,
            speed: 700,
            vertical: false,
            responsive: [
                {
                    breakpoint: 991,
                    settings: "unslick"
                },
            ]
        });

        if (/Android/i.test(navigator.userAgent)) {
            document.querySelectorAll('a[data-fancybox] video').forEach(video => {
                video.style.pointerEvents = 'none';
            });
        }
    }

    if ($('.product-rating__review-listl')) {
        $('.product-rating__review-list').slick({
            touchThreshold: 100,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            dots: false,
            infinite: false,
            mobileFirst: true,
            adaptiveHeight: true,
            speed: 700,
            vertical: false,
            responsive: [
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3,
                    }
                },
            ]
        });
    }

    if ($('#product-detail-related-carrousel')) {
        $('#product-detail-related-carrousel').slick({
            arrows: true,
            prevArrow: $(".group-arrow .group-arrow-prev"),
            nextArrow: $(".group-arrow .group-arrow-next"),
            dots: false,
            infinite: false,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 700,
            responsive: [
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 2,
                        slidesToShow: 2,
                    }
                },
                {
                    breakpoint: 991,
                    settings: {
                        slidesToScroll: 3,
                        slidesToShow: 3,
                    }
                },
                {
                    breakpoint: 1275,
                    settings: {
                        slidesToScroll: 4,
                        slidesToShow: 4,
                    }
                }
            ]
        });

        $('#product-detail-related-carrousel').on('afterChange', function (event, slick, currentSlide, nextSlide) {
            Blazy({
                selector: '.lazy-img',
                successClass: 'loaded-img',
                success: function (element) {
                    setTimeout(function () {
                        var parent = element.previousSibling;
                        try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/, ''); } catch (e) { }
                    }, 200);
                }
            });
        });
    }

    $('#photo-fancy').fancybox();

    // Gallery Scroll — dots navigation
    const galleryScrollArea = document.querySelector('.product-detail__header--photoArea.gallery-scroll');
    const dotsContainer    = document.getElementById('gallery-scroll-dots');

    if (galleryScrollArea && dotsContainer) {
        const photoContainer = document.getElementById('product-photo');
        if (!photoContainer) return;

        // Collect trackable items: <a> with img/video inside
        const items = Array.from(
            photoContainer.querySelectorAll(':scope > a, :scope > li')
        ).filter(el => el.querySelector('img, video, iframe'));

        if (items.length < 2) return; // only apply with 2+ images

        // Build dots
        items.forEach((_, i) => {
            const dot = document.createElement('span');
            dot.className = 'gallery-scroll__dots__dot' + (i === 0 ? ' active' : '');
            dot.setAttribute('aria-label', 'Imagem ' + (i + 1));
            dot.addEventListener('click', () => {
                items[i].scrollIntoView({ behavior: 'smooth', block: 'center' });
            });
            dotsContainer.appendChild(dot);
        });

        const dots = dotsContainer.querySelectorAll('.gallery-scroll__dots__dot');

        // Show dots only while gallery area is visible on screen
        const areaObserver = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                dotsContainer.classList.toggle('is-visible', entry.isIntersecting);
            });
        }, { threshold: 0.05 });

        areaObserver.observe(galleryScrollArea);

        // Track which item is most centred in the viewport
        let activeIndex = 0;

        const itemObserver = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                if (!entry.isIntersecting) return;
                const index = items.indexOf(entry.target);
                if (index === -1) return;
                activeIndex = index;
                dots.forEach((d, i) => d.classList.toggle('active', i === activeIndex));
            });
        }, {
            threshold: 0.5,   // item must cover at least 50% of viewport to activate
            rootMargin: '0px'
        });

        items.forEach(item => itemObserver.observe(item));
    }
})